import {Route} from "react-router-dom";
import UrlsConfig from "@/config/UrlsConfig";
import {lazy} from "react";

const Profile = lazy(() => import('@/pages/Profile/Profile'));

const urlsConfig = new UrlsConfig();

export function profileRoutes() {
    return (
      <>
          <Route path={urlsConfig.profile.to} element={<Profile/>}/>
      </>
    );
}
